import * as React from 'react';

type IGlobeIconProps = React.SVGProps<SVGSVGElement>;

const GlobeIcon: React.FunctionComponent<IGlobeIconProps> = ({
  width = 24,
  height = 24,
  color = '#094FFE',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 37 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M19 30C25.6274 30 31 24.6274 31 18C31 11.3726 25.6274 6 19 6C12.3726 6 7 11.3726 7 18C7 24.6274 12.3726 30 19 30Z'
        stroke={color}
        strokeWidth='1.5'
      />
      <path
        d='M28.312 10.1775C27.2125 11.1915 25.831 12.0135 24.2665 12.5865C22.702 13.1595 20.986 13.4715 19.2445 13.4985C17.5253 13.527 15.8132 13.271 14.1775 12.741C12.5815 12.216 11.158 11.436 10.0045 10.4565M28.483 25.986C27.373 24.912 25.9555 24.0405 24.3325 23.4375C22.6618 22.824 20.8968 22.5068 19.117 22.5C17.3344 22.4827 15.5623 22.774 13.879 23.361C12.241 23.94 10.7995 24.7905 9.6625 25.8465M19 6V30M31 18H7'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  );
};

export default GlobeIcon;
